export default __webpack_public_path__ + "static/Theinhardt-Heavy-Italic-subset-1ca0c57c087f2bcc9ae6c8fd9247772f.woff2";